import React, { useState, useContext } from 'react';
import { ApiContext } from '../../App';
import { toast } from 'react-toastify';
import {
  X,
  Save,
  Target,
  Settings
} from 'lucide-react';

const CreateProcessBizDev = ({ isOpen, onClose, onProcessCreated }) => {
  const API = useContext(ApiContext);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    description: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name.trim()) {
      toast.error('Le nom du processus est requis');
      return;
    }

    setLoading(true);
    try {
      const response = await API.post('/api/process-bizdev', {
        name: formData.name.trim(),
        description: formData.description.trim()
      });

      toast.success('Processus BizDev créé avec succès');
      onProcessCreated && onProcessCreated(response.data);
      onClose();

      // Reset du formulaire
      setFormData({
        name: '',
        description: ''
      });
    } catch (error) {
      console.error('Error creating process:', error);
      toast.error('Erreur lors de la création du processus');
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div
      className="fixed bg-black bg-opacity-50 flex items-center justify-center p-4 z-50"
      style={{
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        margin: 0,
        padding: '16px'
      }}
    >
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-4xl max-h-[90vh] overflow-hidden">
        {/* Header */}
        <div className="bg-gradient-to-r from-blue-600 to-indigo-600 px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3 gap-2" >
              <Target className="text-white" size={24} />
              <h2 className="text-xl font-bold text-white m-0">
                Créer un processus commercial
              </h2>
            </div>
            <button
              onClick={onClose}
              className="text-white hover:bg-white/20 p-2 rounded-lg transition-colors"
            >
              <X size={20} />
            </button>
          </div>
        </div>

        {/* Content */}
        <form onSubmit={handleSubmit} className="p-6 overflow-y-auto max-h-[calc(90vh-80px)]">
          <div className="space-y-6">
            {/* Informations générales */}
            <div className="bg-gray-50 rounded-lg p-4 space-y-4">
              <h3 className="text-lg font-semibold text-gray-800 flex items-center">
                <Settings size={20} className="mr-2" />
                Informations générales
              </h3>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Nom du processus *
                </label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  className="w-full border border-gray-300 rounded-lg p-3 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                  placeholder="Ex: Prospection commerciale Q1 2024"
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Description (optionnelle)
                </label>
                <textarea
                  name="description"
                  value={formData.description}
                  onChange={handleInputChange}
                  rows="3"
                  className="w-full border border-gray-300 rounded-lg p-3 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors resize-none"
                  placeholder="Description du processus, objectifs, cibles..."
                />
              </div>
            </div>

            {/* Info sur les étapes */}
            <div className="bg-blue-50 rounded-lg p-4 border border-blue-200">
              <p className="text-sm text-blue-800">
                <strong>Note :</strong> Les étapes du processus seront créées automatiquement avec la configuration par défaut. Vous pourrez les activer/désactiver après la création du processus.
              </p>
            </div>
          </div>

          {/* Actions */}
          <div className="flex justify-end space-x-3 mt-6 pt-6 border-t border-gray-200">
            <button
              type="button"
              onClick={onClose}
              className="px-6 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
            >
              Annuler
            </button>
            <button
              type="submit"
              disabled={loading}
              className="flex items-center space-x-2 px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-blue-400 transition-colors"
            >
              {loading ? (
                <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
              ) : (
                <Save size={16} />
              )}
              <span>{loading ? 'Création...' : 'Créer le processus'}</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateProcessBizDev;